
  import {Component, Vue, Prop} from "vue-property-decorator";
  import {ICamsPhoto} from "@/modules/Car/interfaces/cams-photo.interface";

  @Component({})
  export default class CameraTypeIcon extends Vue {
    @Prop() cameraType: string;

    iconData = {
      [ICamsPhoto.CameraType.check]: { icon: 'circle-check',  title: 'Контрольная', class: '', },
      [ICamsPhoto.CameraType.enter]: { icon: 'warehouse',     title: 'Въезд',       class: 'green', },
      [ICamsPhoto.CameraType.exit]:  { icon: 'road',          title: 'Выезд',       class: 'orange', },
    };
  }
